angular.module('impactx').service('OutsourcedCommentSaveService', ['$q', '$securityManager', 'dataGen', OutsourcedCommentSaveService]);

function OutsourcedCommentSaveService($q, $securityManager, dataGen) {
    var self = this;

    self.extractComments = function (baseItem) {
        var newExternalComments = null;
        var newInternalComments = null;
        var newApprovalComments = null;
        var newCnfComments = null;
        var newAviComments = null
        var newInvoiceComments = null;
        if (impactX.isDefined(baseItem, 'comments.externalComments.newComments')) {
            newExternalComments = baseItem.comments.externalComments.newComments;
            baseItem.comments.externalComments.newComments = [];
        }
        if (impactX.isDefined(baseItem, 'comments.internalComments.newComments')) {
            newInternalComments = baseItem.comments.internalComments.newComments;
            baseItem.comments.internalComments.newComments = [];
        }
        if (impactX.isDefined(baseItem, 'comments.approvalComments.newComments')) {
            newApprovalComments = baseItem.comments.approvalComments.newComments;
            baseItem.comments.approvalComments.newComments = [];
        }
        if (impactX.isDefined(baseItem, 'comments.cnfComments.newComments')) {
            newCnfComments = baseItem.comments.cnfComments.newComments;
            baseItem.comments.cnfComments.newComments = [];
        }
        if (impactX.isDefined(baseItem, 'comments.aviComments.newComments')) {
            newAviComments = baseItem.comments.aviComments.newComments;
            baseItem.comments.aviComments.newComments = [];
        }
        if (impactX.isDefined(baseItem, 'comments.invoiceComments.newComments')) {
            newInvoiceComments = baseItem.comments.invoiceComments.newComments;
            baseItem.comments.invoiceComments.newComments = [];
        }
        return {
            newExternalComments: newExternalComments,
            newInternalComments: newInternalComments,
            newApprovalComments: newApprovalComments,
            newCnfComments: newCnfComments,
            newAviComments: newAviComments,
            newInvoiceComments: newInvoiceComments
        };
    };

    self.restoreComments = function (baseItem, comments) {
        if (baseItem.comments.externalComments) {
            baseItem.comments.externalComments.newComments = comments.newExternalComments;
        }
        if (baseItem.comments.internalComments) {
            baseItem.comments.internalComments.newComments = comments.newInternalComments;
        }
        if (baseItem.comments.approvalComments) {
            baseItem.comments.approvalComments.newComments = comments.newApprovalComments;
        }
        if (baseItem.comments.cnfComments) {
            baseItem.comments.cnfComments.newComments = comments.newCnfComments;
        }
        if (baseItem.comments.aviComments) {
            baseItem.comments.aviComments.newComments = comments.newAviComments;
        }
    };

    self.saveCommentsByToken = function (token, comments, useCMMNTTable) {
        if (token && comments) {
            return self.saveCompleteComment(comments, 0, token, useCMMNTTable);
        }
        return $q.when();
    }

    self.saveComments = function (commentDataDTO, comments, useCMMNTTable) {
        if (comments && commentDataDTO) {
            return self.saveCompleteComment(comments.newInvoiceComments, 0, commentDataDTO.invoiceComments ? commentDataDTO.invoiceComments.commentToken : null, useCMMNTTable).then(function () {
                return self.saveCompleteComment(comments.aviComments, 0, commentDataDTO.aviComments ? commentDataDTO.aviComments.commentToken : null, useCMMNTTable).then(function () {
                    return self.saveCompleteComment(comments.cnfComments, 0, commentDataDTO.cnfComments ? commentDataDTO.cnfComments.commentToken : null, useCMMNTTable).then(function () {
                        return self.saveCompleteComment(comments.approvalComments, 0, commentDataDTO.approvalComments ? commentDataDTO.approvalComments.commentToken : null, useCMMNTTable).then(function () {
                            return self.saveCompleteComment(comments.newExternalComments, 0, commentDataDTO.externalComments ? commentDataDTO.externalComments.commentToken : null, useCMMNTTable).then(function () {
                                return self.saveCompleteComment(comments.newInternalComments, 0, commentDataDTO.internalComments ? commentDataDTO.internalComments.commentToken : null, useCMMNTTable);
                            })
                        })
                    })
                });
            });
        }
        else {
            return $q.when();
        }
    };

    self.saveCompleteComment = function (commentObject, commentIterator, commentToken, useCMMNTTable) {
        if (commentToken && commentObject && commentObject[commentIterator]) {
            if (commentObject[commentIterator].comment && !commentObject[commentIterator].attachments) {
                var dataObj = {
                    commentToken: commentToken,
                    newComment: commentObject[commentIterator].comment
                };

                return dataGen.postAsForm({}, dataObj, useCMMNTTable ? "/comment/add/cmmnt" : "/comment/add").then(function () {
                    commentIterator++;
                    return self.saveCompleteComment(commentObject, commentIterator, commentToken, useCMMNTTable);
                });
            }
            else if (commentObject[commentIterator].attachments) {
                return self.saveAttachmentAndCallNext(commentObject, commentIterator, commentToken, useCMMNTTable);
            }
        }
        return $q.when();
    };

    self.saveAttachmentAndCallNext = function (commentObject, commentIterator, commentToken, useCMMNTTable) {
        var file = commentObject[commentIterator].attachments.newEntries[0].file;
        var fileData = {
            file: file,
            fileName: file.name,
            commentToken: commentToken
        };

        return dataGen.uploadFile(fileData, useCMMNTTable ? '/comment/addattachmentstream/cmmnt' : '/comment/addattachmentstream').then(function () {
            commentIterator++;
            return self.saveCompleteComment(commentObject, commentIterator, commentToken, useCMMNTTable);
        }, function () {
            commentIterator++;
            return self.saveCompleteComment(commentObject, commentIterator, commentToken, useCMMNTTable);
        });
    }
}
